import type { PropsWithChildren } from 'react';
import type React from 'react';

import { PetitionStatsContext } from '#src/app/pages/petitionDetails/shared/contexts';
import { useApiPetitionStats } from '#src/app/pages/petitionDetails/shared/hooks';

type Props = Readonly<{
	slug: string;
}>;

export const PetitionStatsContextProvider: React.FC<PropsWithChildren<Props>> = ({ slug, children }) => {
	const petitionStatsState = useApiPetitionStats(slug);

	return <PetitionStatsContext.Provider value={petitionStatsState}>{children}</PetitionStatsContext.Provider>;
};
